import React from 'react';
import createSvgIcon from '@mui/icons-material/utils/createSvgIcon';
import parseColor from '../util/parseColor';
import { styled } from '../styled';

const Icon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='none'
    color='inherit'
  >
    <path
      d='m10.25 11.5016 7.075-7.07504c.2-.2.4333-.3.7-.3.2666 0 .5.1.7.3s.3.43334.3.7c0 .26667-.1.5-.3.7l-7.05 7.07504zm2.475 2.475 6.35-6.37504c.2-.2.4375-.3.7125-.3s.5125.1.7125.3.3.4375.3.7125-.1.5125-.3.7125l-6.35 6.35004zm-7.95002 4.75c-1.51667-1.5167-2.275-3.3417-2.275-5.475 0-2.1334.75833-3.95837 2.275-5.47504l3-3 1.475 1.475c.11666.11667.21666.2375.3.3625.08333.125.16666.25417.25.3875l3.70002-3.725c.2-.2.4375-.3.7125-.3s.5125.1.7125.3.3.4375.3.7125-.1.5125-.3.7125l-4.325 4.325-2.12502 2.10004.475.475c.76666.7666 1.13332 1.6833 1.10002 2.75-.0334 1.0666-.44169 1.9916-1.22502 2.775l-1.425-1.4c.38333-.3834.59583-.8375.6375-1.3625.04166-.525-.12917-.9792-.5125-1.3625l-1.175-1.15c-.2-.2-.3-.4375-.3-.7125s.1-.5125.3-.7125l1.425-1.40004c.2-.2.3-.4375.3-.7125s-.1-.5125-.3-.7125l-1.6 1.6c-1.13334 1.13334-1.7 2.48754-1.7 4.06254s.56666 2.9291 1.7 4.0625c1.13333 1.1333 2.49166 1.7 4.07502 1.7 1.5833 0 2.9416-.5667 4.075-1.7l5.975-6c.2-.2.4375-.3.7125-.3s.5125.1.7125.3.3.4375.3.7125-.1.5125-.3.7125l-6 5.975c-1.5167 1.5166-3.3417 2.275-5.475 2.275-2.13336 0-3.95836-.7584-5.47502-2.275zm11.72502 4.3v-2.025c1.1 0 2.0416-.3917 2.825-1.175.7833-.7834 1.175-1.725 1.175-2.825h2.025c0 1.6666-.5875 3.0875-1.7625 4.2625s-2.5959 1.7625-4.2625 1.7625zm-16.025024-16.02504c0-1.66666.587504-3.0875 1.762504-4.2625s2.59583-1.762498 4.2625-1.762498v2.024998c-1.1 0-2.04167.39167-2.825 1.175-.78334.78334-1.175 1.725-1.175 2.825z'
      fill='currentColor'
    />
  </svg>,
  'WavingHand',
);

const ColoredIcon = styled(Icon)(({ theme, color }) => ({
  color: parseColor(theme, color),
}));

export default ColoredIcon;
